///<reference path="UBBParser.ts"/>

namespace fgui {
    export class ToolSet {
        public static startsWith(source: string, str: string, ignoreCase?: boolean): boolean {
            if (!source)
                return false;
            else if (source.length < str.length)
                return false;
            else {
                source = source.substring(0, str.length);
                if (!ignoreCase)
                    return source == str;
                else
                    return source.toLowerCase() == str.toLowerCase();
            }
        }

        public static endsWith(source: string, str: string, ignoreCase?: boolean): boolean {
            if (!source)
                return false;
            else if (source.length < str.length)
                return false;
            else {
                source = source.substring(source.length - str.length);
                if (!ignoreCase)
                    return source == str;
                else
                    return source.toLowerCase() == str.toLowerCase();
            }
        }

        public static trimRight(targetString: string): string {
            var tempChar: string = "";
            for (var i: number = targetString.length - 1; i >= 0; i--) {
                tempChar = targetString.charAt(i);
                if (tempChar != " " && tempChar != "\n" && tempChar != "\r") {
                    break;
                }
            }
            return targetString.substring(0, i + 1);
        }

        public static convertToHtmlColor(argb: number, hasAlpha?: boolean): string {
            var alpha: string;
            if (hasAlpha)
                alpha = (argb >> 24 & 0xFF).toString(16);
            else
                alpha = "";
            var red: string = (argb >> 16 & 0xFF).toString(16);
            var green: string = (argb >> 8 & 0xFF).toString(16);
            var blue: string = (argb & 0xFF).toString(16);
            if (alpha.length == 1)
                alpha = "0" + alpha;
            if (red.length == 1)
                red = "0" + red;
            if (green.length == 1)
                green = "0" + green;
            if (blue.length == 1)
                blue = "0" + blue;
            return "#" + alpha + red + green + blue;
        }

        public static convertFromHtmlColor(str: string, hasAlpha?: boolean): number {
            if (str.length < 1)
                return 0;

            if (str.charAt(0) == "#")
                str = str.substring(1);

            if (str.length == 8)
                return (parseInt(str.substring(0, 2), 16) << 24) + parseInt(str.substring(2), 16);
            else if (hasAlpha)
                return 0xFF000000 + parseInt(str, 16);
            else
                return parseInt(str, 16);
        }

        public static displayObjectToGObject(obj: Laya.Node): GObject {
            while (obj && !(obj instanceof Laya.Stage)) {
                if (obj["$owner"])
                    return obj["$owner"];

                obj = obj.parent;
            }
            return null;
        }

        public static encodeHTML(str: string): string {
            if (!str)
                return "";
            else
                return str.replace(/&/g, "&amp;").replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;").replace(/'/g, "&apos;").replace(/"/g, "&quot;");
        }

        public static clamp(value: number, min: number, max: number): number {
            if (value < min)
                value = min;
            else if (value > max)
                value = max;
            return value;
        }

        public static clamp01(value: number): number {
            if (isNaN(value))
                value = 0;
            else if (value > 1)
                value = 1;
            else if (value < 0)
                value = 0;
            return value;
        }

        public static lerp(start: number, end: number, percent: number): number {
            return (start + percent * (end - start));
        }

        public static repeat(t: number, length: number): number {
            return t - Math.floor(t / length) * length;
        }

        public static distance(x1: number, y1: number, x2: number, y2: number): number {
            return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
        }

        public static setColorFilter(obj: Laya.Sprite, color?: string | number[] | boolean): void {
            var filters: Laya.Filter[] = obj.filters;
            var index = filters ? filters.findIndex(f => f instanceof Laya.ColorFilter) : -1;
            var filter = index !== -1 ? filters[index] as Laya.ColorFilter : null;

            var toApplyColor: any;
            var toApplyGray: boolean;
            var tp: string = typeof (color);
            if (tp == "boolean") //gray
            {
                toApplyColor = filter ? (<any>filter).$_color_ : null;
                toApplyGray = <boolean>color;
            }
            else {
                if (tp == "string") {
                    var arr: any[] = Laya.ColorUtils.create(<any>color).arrColor;
                    if (arr[0] == 1 && arr[1] == 1 && arr[2] == 1)
                        color = null;
                    else {
                        color = [arr[0], 0, 0, 0, 0,
                            0, arr[1], 0, 0, 0,
                            0, 0, arr[2], 0, 0,
                            0, 0, 0, 1, 0];
                    }
                }
                toApplyColor = color;
                toApplyGray = filter ? (<any>filter).$_grayed_ : false;
            }

            if ((!toApplyColor && toApplyColor != 0) && !toApplyGray) {
                if (filter) {
                    filters.splice(index, 1);
                    if (filters.length > 0)
                        obj.filters = filters.concat();
                    else
                        obj.filters = null;
                }
                return;
            }

            if (!filter) {
                filter = new Laya.ColorFilter();
            }
            if (!filters)
                obj.filters = [filter];
            else if (index === -1)
                obj.filters = filters.concat(filter);

            (<any>filter).$_color_ = toApplyColor;
            (<any>filter).$_grayed_ = toApplyGray;

            filter.reset();

            if (toApplyGray)
                filter.gray();
            else if (toApplyColor.length == 20)
                filter.setByMatrix(toApplyColor);
            else
                filter.setByMatrix(getColorMatrix(toApplyColor[0], toApplyColor[1], toApplyColor[2], toApplyColor[3]));
        }
    }

    let helper: ColorMatrix = new ColorMatrix();
    function getColorMatrix(p_brightness: number, p_contrast: number, p_saturation: number, p_hue: number, result?: number[]): Array<number> {
        result = result || new Array<number>(ColorMatrix.length);
        helper.reset();
        helper.adjustColor(p_brightness, p_contrast, p_saturation, p_hue);
        helper.matrix.forEach((e, i) => result[i] = e);
        return result;
    }
}